import { getLocalStorageInfo } from "../../utils";
export const halcyonInstance = [484].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const smbcInstance = [465].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const acumenCamo = getLocalStorageInfo()?.user?.security_groups?.find(item => item?.name === "Acumen Camo")